import internalTransfer from './internal-transfer';

const getInitialState = () => ({
  isDarkMode: localStorage.getItem('isDarkMode') === 'true',
});

const mutations = {
  UPDATE_DARK_MODE(state, newVal) {
    state.isDarkMode = newVal;
    localStorage.setItem('isDarkMode', newVal);
  },
};

export default {
  namespaced: true,
  state: getInitialState(),
  mutations,
  modules: { internalTransfer },
};
